import Box from '@mui/material/Box';

const TemplatePage = (props) => {

    const boxStyles = {
        backgroundColor: "#101011",
        maxWidth: '100%',
        maxHeight: '100%'
    }

    return ( 
        <Box {...boxStyles}>
            {props.children}
        </Box>
    );
}
 
export default TemplatePage;